/* Nichey goal bar: keeps product-page and cart-page bars in sync after cart changes.
   The cart drawer bar is re-rendered by the theme, so it is never touched here.
   No work on page load; one /cart.js request only after a cart change. */
(() => {
  if (window.NyGoalBar) return;
  window.NyGoalBar = true;
  const T1 = 150000, T2 = 300000;
  const outside = () => [...document.querySelectorAll('[data-ny-goal]')].filter(el => !el.closest('hdt-cart-drawer'));
  if (!outside().length && !document.querySelector('hdt-main-cart')) return;

  const money = (el, cents) =>
    (el.dataset.pre || '') + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 }) + (el.dataset.suf || '');
  const esc = s => s.replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const paint = (el, total) => {
    let tpl, left = '';
    if (total < T1) { tpl = el.dataset.m1; left = money(el, T1 - total); }
    else if (total < T2) { tpl = el.dataset.m2; left = money(el, T2 - total); }
    else tpl = el.dataset.m3;
    el.dataset.total = total;
    el.style.setProperty('--ny-goal-p', Math.min(1, total / T2));
    el.classList.toggle('is-ship', total >= T1);
    el.classList.toggle('is-gift', total >= T2);
    const msg = el.querySelector('.ny-goal__msg');
    if (msg) msg.innerHTML = (tpl || '').split('|').map(l => '<span class="ny-goal__line">' + esc(l).replace('[X]', '<strong>' + esc(left) + '</strong>') + '</span>').join('');
    const track = el.querySelector('[role="progressbar"]');
    if (track) track.setAttribute('aria-valuenow', Math.min(3000, Math.floor(total / 100)));
  };

  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const bars = outside();
      if (!bars.length) return;
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        bars.forEach(el => {
          let total = cart.total_price;
          if (el.dataset.variant && !cart.items.some(i => String(i.variant_id) === el.dataset.variant)) {
            total += Number(el.dataset.price || 0);
          }
          paint(el, total);
        });
      } catch (e) { /* keep the server-rendered state */ }
    }, 250);
  };

  document.addEventListener('cart:update', refresh);
  const watch = () => {
    // Only structural re-renders of the cart areas trigger a refresh (debounced).
    document.querySelectorAll('hdt-main-cart, hdt-cart-drawer').forEach(node =>
      new MutationObserver(refresh).observe(node, { childList: true, subtree: true })
    );
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
